module.exports = __webpack_public_path__ + "media/images/off_white_1_4_circle-496aaa025fc38e73973dfeb2cdd5c78c.png";